import { render, staticRenderFns } from "./home_comb.vue?vue&type=template&id=e04b4376&scoped=true"
import script from "./home_comb.vue?vue&type=script&lang=js"
export * from "./home_comb.vue?vue&type=script&lang=js"
import style0 from "./home_comb.vue?vue&type=style&index=0&id=e04b4376&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04b4376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e04b4376')) {
      api.createRecord('e04b4376', component.options)
    } else {
      api.reload('e04b4376', component.options)
    }
    module.hot.accept("./home_comb.vue?vue&type=template&id=e04b4376&scoped=true", function () {
      api.rerender('e04b4376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_comb.vue"
export default component.exports